document.documentElement.classList.add('js-ready');

document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.querySelector('#ProductMainImage');
  const thumbs = document.querySelectorAll('.product-thumb');

  function scrollThumbIntoView(thumb) {
    if (!thumb) return;
    const strip = thumb.closest('.product-thumbs');
    if (!strip) return;
    const s = strip.getBoundingClientRect();
    const t = thumb.getBoundingClientRect();
    if (t.left < s.left) strip.scrollBy({ left: t.left - s.left - 8, behavior: 'smooth' });
    else if (t.right > s.right) strip.scrollBy({ left: t.right - s.right + 8, behavior: 'smooth' });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      const src = thumb.getAttribute('data-full-src');
      const alt = thumb.getAttribute('data-alt') || '';
      if (src) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.setAttribute('src', src);
      }
      mainImage.setAttribute('alt', alt);

      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      scrollThumbIntoView(thumb);
    });
  });

  /* Carrousel de miniatures : flèches précédent / suivant */
  document.querySelectorAll('.product-thumbs-carousel').forEach(function (car) {
    const strip = car.querySelector('.product-thumbs');
    const prev = car.querySelector('.thumbs-arrow--prev');
    const next = car.querySelector('.thumbs-arrow--next');
    if (!strip) return;
    function step() { return Math.max(160, strip.clientWidth * 0.8); }
    if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  const price = document.querySelector('#ProductPrice');
  const comparePrice = document.querySelector('#ProductComparePrice');
  const submit = document.querySelector('#ProductSubmit');
  const hiddenId = document.querySelector('#ProductSelectedVariant');
  const variantDataEl = document.querySelector('#VariantData');

  function setMainImage(url) {
    if (!url || !mainImage) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.setAttribute('src', url);
    thumbs.forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-full-src') === url);
    });
    const active = Array.prototype.filter.call(thumbs, function (t) { return t.classList.contains('is-active'); })[0];
    scrollThumbIntoView(active);
  }

  if (variantDataEl && hiddenId) {
    let variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }

    const optionGroups = document.querySelectorAll('.product-option');
    const swatches = document.querySelectorAll('.product-swatch');

    let selected = new Array(optionGroups.length).fill(null);

    function valueCount(idx) {
      const g = optionGroups[idx];
      return g ? g.querySelectorAll('.product-swatch').length : 0;
    }
    function priorChosen(idx) {
      for (var i = 0; i < idx; i++) { if (selected[i] === null && valueCount(i) > 1) return false; }
      return true;
    }
    /* Un groupe dépendant (2e, 3e…) est verrouillé tant qu'un groupe précédent
       à choix multiple n'est pas sélectionné. Un groupe à valeur unique n'est jamais verrouillé. */
    function groupLocked(idx) {
      if (idx === 0 || valueCount(idx) <= 1) return false;
      return !priorChosen(idx);
    }
    function firstMissingPriorName(idx) {
      for (var i = 0; i < idx; i++) {
        if (selected[i] === null && valueCount(i) > 1) {
          return optionGroups[i] ? (optionGroups[i].getAttribute('data-option-name') || '') : '';
        }
      }
      return '';
    }
    /* Une valeur est-elle disponible (stock) compte tenu des autres sélections ? */
    function valuePossible(idx, val) {
      return variants.some(function (v) {
        if (!v.available) return false;
        return v.options.every(function (o, i) {
          if (i === idx) return o === val;
          return selected[i] === null || o === selected[i];
        });
      });
    }
    /* Réinitialise les sélections d'autres groupes devenues impossibles. */
    function pruneInvalid(changedIdx) {
      optionGroups.forEach(function (group) {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        if (idx === changedIdx) return;
        if (selected[idx] !== null && !valuePossible(idx, selected[idx])) selected[idx] = null;
      });
    }

    /* Auto-sélection des options qui n'ont qu'une seule valeur possible
       (variante unique, ou chaque type de variante avec une seule option). */
    optionGroups.forEach(function (group) {
      const idx = parseInt(group.getAttribute('data-option-index'), 10);
      const sws = group.querySelectorAll('.product-swatch');
      if (sws.length === 1) { selected[idx] = sws[0].getAttribute('data-value'); }
    });

    const alertBox = document.querySelector('#ProductOptionAlert');
    const alertText = alertBox ? alertBox.querySelector('.product-alert__text') : null;
    function showAlert(msg, warn) {
      if (!alertBox) return;
      if (!msg) { alertBox.hidden = true; return; }
      if (alertText) alertText.textContent = msg;
      alertBox.classList.toggle('product-alert--warn', !!warn);
      alertBox.hidden = false;
    }

    function findVariant() {
      return variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
    }

    function refreshAvailability() {
      optionGroups.forEach(function (group) {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        const locked = groupLocked(idx);
        group.classList.toggle('product-option--locked', locked);
        const hint = group.querySelector('.product-option__hint');
        if (hint) {
          if (locked) { hint.textContent = 'Choisissez d\'abord « ' + firstMissingPriorName(idx) + ' »'; hint.hidden = false; }
          else { hint.hidden = true; }
        }
        group.querySelectorAll('.product-swatch').forEach(function (sw) {
          if (locked) { sw.classList.add('is-disabled'); sw.classList.remove('is-unavailable'); return; }
          sw.classList.remove('is-disabled');
          sw.classList.toggle('is-unavailable', !valuePossible(idx, sw.getAttribute('data-value')));
        });
      });
    }

    /* Tant que l'utilisateur n'a pas cliqué une option, l'auto-sélection ne doit
       pas modifier le rendu de départ (image, libellé, surbrillance du swatch).
       Elle reste néanmoins fonctionnelle (variante, prix, bouton d'achat). */
    var userInteracted = false;

    function updateUI() {
      if (userInteracted) {
        optionGroups.forEach(function (group) {
          const idx = parseInt(group.getAttribute('data-option-index'), 10);
          const lbl = group.querySelector('.product-option__selected');
          if (lbl) lbl.textContent = selected[idx] ? selected[idx].split(' - ')[0] : 'À choisir';
          group.querySelectorAll('.product-swatch').forEach(function (sw) {
            sw.classList.toggle('is-selected', sw.getAttribute('data-value') === selected[idx]);
          });
        });
      }

      const total = selected.length;
      const chosen = selected.filter(function (s) { return s !== null; }).length;
      const complete = total > 0 && chosen === total;

      if (!complete) {
        hiddenId.value = '';
        if (submit) { submit.disabled = true; submit.textContent = 'Choisissez une option'; }
        /* Sélection partielle : dès qu'au moins un groupe est choisi, on met à jour
           l'image principale d'après la 1re variante correspondant aux choix en cours
           (l'image est portée par le 1er groupe). Uniquement après interaction. */
        if (userInteracted && chosen > 0) {
          var partial = variants.filter(function (v) {
            return v.options.every(function (o, i) { return selected[i] === null || o === selected[i]; });
          })[0];
          if (partial && partial.image) setMainImage(partial.image);
        }
        if (chosen === 0) {
          showAlert('Sélectionnez vos options pour afficher le prix et ajouter au panier.', false);
        } else {
          showAlert('Encore une étape : choisissez toutes les options pour mettre à jour le prix et activer l\'ajout au panier.', false);
        }
        return; /* on garde le prix « À partir de » jusqu'à la sélection complète */
      }

      const v = findVariant();
      if (v && v.available) {
        hiddenId.value = v.id;
        if (price && v.price) price.textContent = v.price;
        if (comparePrice) {
          if (v.compare_at_price) { comparePrice.textContent = v.compare_at_price; comparePrice.hidden = false; }
          else { comparePrice.textContent = ''; comparePrice.hidden = true; }
        }
        if (submit) { submit.disabled = false; submit.textContent = 'Ajouter au panier'; }
        if (userInteracted) setMainImage(v.image);
        showAlert(null);
      } else if (v && !v.available) {
        hiddenId.value = '';
        if (price && v.price) price.textContent = v.price;
        if (submit) { submit.disabled = true; submit.textContent = 'Produit indisponible'; }
        if (userInteracted) setMainImage(v.image);
        showAlert('Cette option est actuellement indisponible. Choisissez-en une autre.', true);
      } else {
        hiddenId.value = '';
        if (submit) { submit.disabled = true; submit.textContent = 'Combinaison indisponible'; }
        showAlert('Cette combinaison n\'est pas disponible. Essayez une autre option.', true);
      }
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        const idx = parseInt(sw.getAttribute('data-option-index'), 10);
        if (groupLocked(idx)) {
          showAlert('Choisissez d\'abord « ' + firstMissingPriorName(idx) + ' ».', true);
          return;
        }
        if (sw.classList.contains('is-unavailable') || sw.classList.contains('is-disabled')) {
          return; /* option épuisée ou indisponible : non sélectionnable */
        }
        userInteracted = true;
        selected[idx] = sw.getAttribute('data-value');
        pruneInvalid(idx);
        updateUI();
        refreshAvailability();
      });
    });

    updateUI();
    refreshAvailability();
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) {
        menu.removeAttribute('open');
      }
    });
  });
});


/* MIORRA runtime guards — corrige les contenus Shopify hors thème */
document.addEventListener('DOMContentLoaded', function(){
  var customSelectors = ['.miorra-brand-page','.miorra-guide','.miorra-griffe','.miorra-article','.miorra-cache','.miorra-hauteur','.miorra-poils','.miorra-meal','.miorra-catnip'];
  var hasCustom = customSelectors.some(function(sel){ return document.querySelector(sel); }) || !!document.querySelector('.rte-page .miorra-besoins-hub');
  if (hasCustom) {
    document.querySelectorAll('.rte-page, .page-shell:not(.collection-page):not(.product-page)').forEach(function(shell){ shell.classList.add('page-shell--miorra-custom'); });
    document.querySelectorAll('.rte-content:not(.collection-description-featured)').forEach(function(rte){
      if (customSelectors.some(function(sel){ return rte.querySelector(sel); }) || rte.closest('.rte-page') && rte.querySelector('.miorra-besoins-hub')) rte.classList.add('rte-content--full');
    });
    document.querySelectorAll('.page-shell--miorra-custom:not(.collection-page) > .page-hero').forEach(function(hero){ hero.remove(); });
  }

  // Supprime toute adresse mail visible en footer, y compris si une ancienne section reste en cache.
  document.querySelectorAll('.footer-email, .site-footer a[href^="mailto:"], a[href="mailto:contact@miorra.fr"]').forEach(function(el){
    var parent = el.closest('p');
    if (parent && parent.classList.contains('footer-email')) parent.remove();
    else el.remove();
  });

  // Ancien header : remplace le coeur par un vrai libellé Compte.
  document.querySelectorAll('.site-header a[href="/account"]').forEach(function(a){
    var raw = (a.textContent || '').trim();
    if (raw === '♡' || raw === '♥' || raw.length <= 2) {
      a.classList.add('account-link','account-link--patched');
      a.setAttribute('aria-label','Compte client');
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 12.25a4.35 4.35 0 1 1 0-8.7 4.35 4.35 0 0 1 0 8.7Zm0-2a2.35 2.35 0 1 0 0-4.7 2.35 2.35 0 0 0 0 4.7Zm-7.2 9.2c.75-3.25 3.55-5.45 7.2-5.45s6.45 2.2 7.2 5.45c.13.55-.3 1.05-.87 1.05H5.67c-.57 0-1-.5-.87-1.05Zm2.38-.95h9.64c-.82-1.55-2.5-2.5-4.82-2.5s-4 .95-4.82 2.5Z"/></svg><span>Compte</span>';
    }
  });

  // Réécriture des anciens liens blog/pages vers la nouvelle structure.
  var linkMap = {
    '/blogs/conseils/pourquoi-chat-interieur-sennuie':'/pages/chat-qui-s-ennuie',
    '/blogs/conseils/pourquoi-chat-interieur-s-ennuie':'/pages/chat-qui-s-ennuie',
    '/blogs/conseils/pourquoi-chat-griffe-canape':'/pages/empecher-chat-griffer-canape',
    '/blogs/conseils/pourquoi-chat-aime-se-cacher':'/pages/pourquoi-mon-chat-se-cache',
    '/blogs/conseils/pourquoi-chats-aiment-dormir-hauteur':'/pages/pourquoi-chat-dort-en-hauteur',
    '/blogs/conseils/pourquoi-les-chats-aiment-dormir-en-hauteur':'/pages/pourquoi-chat-dort-en-hauteur',
    '/blogs/conseils/organiser-coin-repas-chat-interieur':'/pages/ou-placer-gamelle-chat',
    '/blogs/conseils/pourquoi-chat-perd-beaucoup-poils':'/pages/chat-qui-perd-ses-poils',
    '/blogs/conseils/pourquoi-chat-perd-beaucoup-ses-poils':'/pages/chat-qui-perd-ses-poils',
    '/blogs/conseils/matatabi-ou-herbe-a-chat-difference':'/pages/matatabi-ou-herbe-a-chat',
    '/pages/conseils-chat-interieur':'/pages/chat-interieur'
  };
  document.querySelectorAll('a[href]').forEach(function(a){
    var href = a.getAttribute('href');
    if (!href) return;
    Object.keys(linkMap).forEach(function(oldPath){
      if (href === oldPath || href.indexOf(oldPath + '?') === 0 || href.indexOf(oldPath + '#') === 0) {
        a.setAttribute('href', href.replace(oldPath, linkMap[oldPath]));
      }
    });
  });
});
